/**
 * Resolve the asset slug for the current selection — the SINGLE key shared by the
 * 360 flipbook frames AND the baked AR (USDZ/GLB). Mirrors Engine.ts GLB resolution:
 * the slug is the GLB basename (e.g. `large2-limestone`) for the chosen
 * material × colorway × forme. Keeping this in one place means the spin frames and
 * the AR file can never drift to different keys.
 */
import type { ConfigState, ProductConfig } from "@/types";

export function resolveSlug(product: ProductConfig, s: ConfigState): string | null {
  const mats = product.materials ?? [];
  const mat = mats.find((m) => m.id === s.materialId) ?? mats[0];
  const cw = mat?.colorways.find((c) => c.id === s.colorwayId) ?? mat?.colorways[0];
  const glb = cw?.glbByForme?.[s.formeId] ?? cw?.glb ?? null;
  if (!glb) return null;
  return glb.split("/").pop()!.replace(/\.glb$/i, "");
}
